import { useTranslation } from 'react-i18next'

import { isEventKeyEnter, preventDefault } from '../../../../../utils/events'
import { InputField } from '../../../../Input'
import { QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SEARCH } from '../../../CalendarSettings.constants'

import * as styles from './TaskTypesFieldSearch.module.css'

import SearchIcon from '../../../../../icons/search.svg'

function TaskTypesFieldSearch({ value, onChange }) {
  const { t } = useTranslation()

  function handleKeyDown(event) {
    if (isEventKeyEnter(event)) {
      preventDefault(event)
    }
  }

  return (
    <InputField
      afterIconProps={{ Icon: SearchIcon }}
      inputProps={{ onKeyDown: handleKeyDown }}
      placeholder={t('CalendarSettings.TaskTypesSearchPlaceholderKey')}
      qaName={QA_NAME_CALENDAR_SETTINGS_TASK_TYPES_SEARCH}
      value={value}
      wrapperClassName={styles.TaskTypesFieldSearch}
      onChange={onChange}
    />
  )
}

export default TaskTypesFieldSearch
